import { css } from 'styled-components';
import { titleMedium, titleSmall, textWideSpacing } from 'styles-js/mixins/typography';

export const markdownStyles = css`
  p {
    ${textWideSpacing}
  }

  p, a, img, button, iframe {
    margin-bottom: 20px;
  }

  h3, h4, h5 {
    margin-bottom: 20px;
    margin-top: 30px;
  }

  li {
    margin-bottom: 10px;
  }

  /* Prevent h1 and h2 as large as the existing on the page. e.g. program title, community name */
  h1, h2, h3 {
    ${titleMedium};

    @media (${props => props.theme.underScreenSmall}) {
      ${titleSmall};
      font-weight: ${({ theme }) => theme.fontWeightBoldTitle};
    }
  }

  h4, h5 {
    ${titleSmall};
  }

  img {
    display: block;
    max-width: 100%;
  }

  .btn {
    display: block;
  }

  iframe {
    max-width: 100%;

    @media (${props => props.theme.underScreenSmall}) {
      width: 100%;
    }
  }

  /* this was added to change the programs quiz border */
  iframe:not([frameborder]) {
    border: solid 2px ${props => props.theme.colorGreyLight};
  }
`;
